var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { role: "main" } },
    [
      _c("h1", { attrs: { tabindex: "-1" } }, [
        _vm._v(_vm._s(_vm.$t("Registration.Title")))
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("Registration.BasicUser.Description")))]),
      _vm._v(" "),
      _c("ValidationObserver", {
        ref: "registerUserObserver",
        attrs: { slim: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              var errors = ref.errors
              return [
                _vm.user
                  ? _c(
                      "form",
                      {
                        staticClass: "mb-5",
                        attrs: { id: "registerUserForm" },
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.register(invalid, errors)
                          }
                        }
                      },
                      [
                        _c("text-input-row", {
                          attrs: {
                            title: "Registration.FirstName",
                            id: "firstname",
                            required: true,
                            rules: { name: true },
                            providerMode: "aggressive"
                          },
                          model: {
                            value: _vm.user.firstName,
                            callback: function($$v) {
                              _vm.$set(_vm.user, "firstName", $$v)
                            },
                            expression: "user.firstName"
                          }
                        }),
                        _vm._v(" "),
                        _c("text-input-row", {
                          attrs: {
                            title: "Registration.LastName",
                            id: "lastname",
                            required: true,
                            rules: { name: true },
                            providerMode: "aggressive"
                          },
                          model: {
                            value: _vm.user.lastName,
                            callback: function($$v) {
                              _vm.$set(_vm.user, "lastName", $$v)
                            },
                            expression: "user.lastName"
                          }
                        }),
                        _vm._v(" "),
                        _c("text-label-row", {
                          attrs: {
                            title: "Registration.Email",
                            id: "email",
                            labelClass:
                              "col-12 col-md-4 col-lg-3 col-form-label pb-0 pb-md-2",
                            valueClass: "col-12 col-md-8 col-lg-9 pt-0 pt-md-2"
                          },
                          model: {
                            value: _vm.user.email,
                            callback: function($$v) {
                              _vm.$set(_vm.user, "email", $$v)
                            },
                            expression: "user.email"
                          }
                        }),
                        _vm._v(" "),
                        _c("text-label-row", {
                          attrs: {
                            title: "Registration.OrganisationName",
                            id: "organisationname",
                            labelClass:
                              "col-12 col-md-4 col-lg-3 col-form-label pb-0 pb-md-2",
                            valueClass: "col-12 col-md-8 col-lg-9 pt-0 pt-md-2"
                          },
                          model: {
                            value: _vm.user.organisationName,
                            callback: function($$v) {
                              _vm.$set(_vm.user, "organisationName", $$v)
                            },
                            expression: "user.organisationName"
                          }
                        }),
                        _vm._v(" "),
                        _c("text-input-row", {
                          attrs: {
                            title: "Registration.Password",
                            providerName: "newPassword",
                            id: "new_password",
                            type: "password",
                            required: true,
                            rules: { password: true },
                            providerMode: "aggressive"
                          },
                          model: {
                            value: _vm.newPassword,
                            callback: function($$v) {
                              _vm.newPassword = $$v
                            },
                            expression: "newPassword"
                          }
                        }),
                        _vm._v(" "),
                        _c("text-input-row", {
                          attrs: {
                            title: "Registration.ConfirmPassword",
                            id: "confirm_password",
                            type: "password",
                            required: true,
                            rules: {
                              passwordConfirm: "@newPassword",
                              password: true
                            },
                            providerMode: "aggressive"
                          },
                          model: {
                            value: _vm.confirmPassword,
                            callback: function($$v) {
                              _vm.confirmPassword = $$v
                            },
                            expression: "confirmPassword"
                          }
                        }),
                        _vm._v(" "),
                        _c("check-box-boolean-with-button", {
                          attrs: {
                            title: "TermsOfUse.AcceptTermsOfUse",
                            id: "acceptTerms",
                            btnid: "showTermsBtn",
                            label: "TermsOfUse.AcceptTermsOfUse",
                            required: true,
                            disabled: _vm.approveTermsDisabled,
                            btndisabled: _vm.processing,
                            "aria-label": _vm.$t(
                              "TermsOfUse.ShowTermsButtonBelow"
                            ),
                            instructionKey:
                              "TermsOfUse.AcceptTermsOfUse_Instructions",
                            providerMode: "aggressive"
                          },
                          on: { btnClick: _vm.showTerms },
                          model: {
                            value: _vm.termsApproved,
                            callback: function($$v) {
                              _vm.termsApproved = $$v
                            },
                            expression: "termsApproved"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-secondary mt-2 login-page-button",
                              attrs: {
                                type: "submit",
                                disabled: _vm.isSendBtnDisabled(!invalid),
                                "aria-disabled": _vm.processing
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("Registration.Btn_Continue")) +
                                  "\n        "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }